let loading:Promise<any>|null=null;
declare global {interface Window{google?:{maps:any};__bossPilotMapsReady?:()=>void}}
export function routeMapConfig(){const env=(import.meta as unknown as {env:Record<string,string>}).env;return{key:env.VITE_GOOGLE_MAPS_BROWSER_KEY,mapId:env.VITE_GOOGLE_MAPS_MAP_ID};}
export async function loadRouteMaps(){
 if(window.google?.maps?.importLibrary)return window.google.maps;
 if(loading)return loading;
 const {key}=routeMapConfig();if(!key)throw new Error('MAP_NOT_CONFIGURED');
 loading=new Promise((resolve,reject)=>{
  const script=document.createElement('script');
  const failed=()=>{clearTimeout(timer);loading=null;script.remove();delete window.__bossPilotMapsReady;reject(new Error('MAP_UNAVAILABLE'));};
  const timer=window.setTimeout(failed,15000);
  window.__bossPilotMapsReady=()=>{clearTimeout(timer);delete window.__bossPilotMapsReady;resolve(window.google!.maps);};
  script.src=`https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&loading=async&libraries=marker&callback=__bossPilotMapsReady`;script.async=true;script.onerror=failed;document.head.appendChild(script);
 });
 return loading;
}
